import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { BaseComponent } from 'src/app/shared/baseComponent';

import { Google_map } from 'src/app/shared/google_map';
import { Kmlmanager } from 'src/app/shared/kmlmanager';
import { Geoutil } from 'src/app/shared/geoutil';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-gpslist',
  templateUrl: './gpslist.component.html',
  styleUrls: ['./gpslist.component.css']
})
export class GpslistComponent extends BaseComponent implements OnInit {
  @ViewChild('pagemap', { static: true }) mapElement: any = {}
  phoneinfo = ''
  gpslogs: any = []
  organizations: any = []
  scenarios: any = []
  selectedScenario: any = {}
  scenarioId = 0
  overview: any = []
  scenariooverview: any = []
  scenariolayout: any = {}
  scenario: any = {}
  google_map: Google_map

  showPhonInfos = false
  showRecords = false
  showmapheader = false;

  heightmin = 100
  heightmax = 0

  counter = 0
  walkInterval = "200"
  googlemapcircles: any = [];
  showAccuracy :any;

  sortByOrg = true
  sortByDate = true
  sortArray: any = []

  constructor(injector: Injector) { super(injector) }

  async ngOnInit() {
    this.loader.show();

    this.scenarios = await this.db.get("scenario", "getScenarios");
    this.organizations = await this.db.get("organization", "getOrganizations");
    this.overview = await this.db.get("gpslog", "GetGPSLogsOverview");
    this.overview.forEach((over: any) => {
      let scen = this.scenarios.find((x: any) => x.id == over.id)
      over.scenarioname = ""
      over.organizationname = ""
      over.date = over.firstRecord.dateCreated  //so you can sort 
      if (scen != null) {
        over.scenarioname = scen.name
        
        let org = this.organizations.find((x: any) => x.id == scen.organizationId)
        if (org != null) over.organizationname = org.name
      }
    })
    //this.sortBy("date")
    this.loader.hide();
  }

  async getData() {
    this.loader.show();
    this.gpslogs = await this.db.get("gpslog", "GetLogsByScenarioAndPhoneInfo", {scenarioid: this.scenarioId, phoneinfo: this.phoneinfo });
    this.loader.hide();
  }

  async selectByScnearioId(scen: any) {
    this.loader.show();
    this.selectedScenario = scen
    this.scenariooverview = await this.db.get("gpslog", "GetNRecByPhoneinfoForScenarioid", { scenarioid: scen.id });
    this.scenariooverview.forEach((so:any)=>{
      so.date = so.firstRecord.dateCreated
      so.selected=false
    })
    this.scenarioId = scen.id
    this.showPhonInfos = true
    this.loader.hide();
  }

  async deleteAllScenario(b: any) {
    this.confirm.show("Do you really want to delete tall records for scenario " + b.scenarioname + "?",
      () => {
        this.deleteRecordsByScen(b.id)
      }, () => {
        this.toast.info("Nothing to do")
      })
  }

  async deleteAllPhoneInfo(b: any) {
    this.confirm.show("Do you really want to delete tall records for phone info " + b.name + "?",
      () => {
        this.deleteRecords(b.name)
      }, () => {
        this.toast.info("Nothing to do")
      })
  }

  
  async deleteRecords(phoneinfo: string){
    await this.db.delete("gpslog", "deleteGPSLogByScenAndPhoneInfo", { scenarioid: this.scenarioId, phoneinfo: phoneinfo  });
    this.scenariooverview = await this.db.get("gpslog", "GetNRecByPhoneinfoForScenarioid", { scenarioid: this.scenarioId });
  }
  async deleteRecordsByScen(scenarioId:number){
    await this.db.delete("gpslog", "deleteGPSLogByScen", { scenarioid: scenarioId});
    this.scenariooverview = []
    this.overview = await this.db.get("gpslog", "GetGPSLogsOverview");
  }
  
  async selectByPhoneInfo(b: any) {
    this.showmapheader = true;
    this.showPhonInfos = false
    this.phoneinfo = b.name
    this.gpslogs = await this.db.get("gpslog", "getgpslogsbyphoneinfo", { phoneinfo: b.name });
    this.scenario = await this.db.get("scenario", "getscenario", { id: this.scenarioId })

    if (this.scenario.geometryJson.length > 5) {
      this.scenariolayout = JSON.parse(this.scenario.geometryJson)
      this.showMap()
    }
  }

  showMap() {
    this.google_map = new Google_map()
    let latlng = this.scenariolayout.center
    let zoom = this.getZoom()
    this.google_map.init(this.mapElement.nativeElement, latlng, zoom)
    this.google_map.setMarker(latlng, "Center");

    this.scenariolayout.contours.forEach((p: any, i: number) => {
      let color = this.scenariolayout.contourdefinitions[i].color;
      this.google_map.addPolygon(p, color)
    })
    this.heightmin = 100
    this.heightmax = 0
    this.gpslogs.forEach((l: any) => {
      let latlng = { lat: l.latitude, lng: l.longitude }
      if (l.height > this.heightmax) { this.heightmax = l.height}
      if (l.height < this.heightmin) this.heightmin = l.height
    })

    this.googlemapcircles = []
    this.gpslogs.forEach((l: any,index: number) => {
      
      this.drawLog(index)
    })

  }

  componentToHex(c:number) {
    let i = Math.floor(c)
    let hex = i.toString(16);
    return hex.length == 1 ? "0" + hex : hex;
  }
  
  rgbToHex(r:number, g:number, b:number) {
    return "#" + this.componentToHex(r) + this.componentToHex(g) + this.componentToHex(b);
  }
  

  getZoom() {
    let result = 14
    let min = 0
    let max = 0
    if (this.scenariolayout.contours.length > 0) {
      min = this.scenariolayout.contours[0][0].lat
      max = this.scenariolayout.contours[0][0].lat
      this.scenariolayout.contours.forEach((c: any) => {
        c.forEach((ll: any) => {
          if (ll.lat < min) min = ll.lat
          if (ll.lat > max) max = ll.lat
        })
      })
      let diff = max - min
      if (diff < 0.010) result = 15
      if (diff < 0.002) result = 17
    }
    return result
  }
  showWalk(){
    this.clearCircles()
    this.counter = 0
    this.repeatLoop()
  }

  repeatLoop() {
    console.log(this.counter);
    this.drawLog(this.counter)
    this.counter++;
    if (this.counter < this.gpslogs.length) {
      let interval = parseInt(this.walkInterval) * 1
      setTimeout(this.repeatLoop.bind(this), interval); // 1000 milliseconds = 1 second
    }
  }

  clearCircles(){
    this.googlemapcircles.forEach((c:any) =>{
      c.setMap(null);
    })
    this.googlemapcircles = []
  }

  drawLog(index: number){
    let l = this.gpslogs[index]
    let r = 255 * (l.height / this.heightmax)
    let b = 255 - 255 * (l.height / this.heightmax)
    let sColor = this.rgbToHex(r,0,b)
    if (this.showAccuracy) sColor = this.rgbToHex(0,255,0)
    let latlng = { lat: l.latitude, lng: l.longitude }
    let radius = this.showAccuracy  ? l.accuracy : 2
    let transparency =  this.showAccuracy  ? 0.1 : 1.0
    let circle = this.google_map.addCircleNoTrans(latlng, radius, sColor,transparency);
    this.googlemapcircles.push(circle)
  }
  async deleteSelected(){
    let ids:any = []
    this.scenariooverview.forEach((so:any)=>{
      if (so.selected == true) ids.push(so.name)
    })
    await this.db.post("gpslog","deleteGPSLogPhoneList",ids)
    this.selectByScnearioId(this.selectedScenario)
  }
  async downloadScenario(id: any){
    this.loader.show()

    let data = await this.db.get("gpslog", "GetGPSLogsByScenarioId", { id: id })
    this.downloadFile(data)
    this.loader.hide()
  }

  downloadFile(data: any) {
    const replacer = (key: any, value: any) => value === null ? '' : value; // specify how you want to handle null values here
    const header = Object.keys(data[0]);
    let csv = data.map((row: any) => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
    csv.unshift(header.join(','));
    let csvArray = csv.join('\r\n');

    var blob = new Blob([csvArray], { type: 'text/csv' })
    saveAs(blob, "gpslogs.csv");
  }


}
